export const SELF_CARE = {
  main: '/redirect/',
};
